export default "__VITE_ASSET__BpTgq2WX__"